import Axios from "axios";
import {
  TCH_GET_CATEGORIES,
  CLEAR_ERRORS,
  GET_ERRORS,
  TCH_LOADING_CATEGORIES,
  TCH_LOADING_CATEGORY,
  TCH_GET_CATEGORY,
  TCH_UPDATE_CATEGORY,
  TCH_UPDATE_MARKING
} from "../types";
const token = document.querySelector('meta[name="csrf-token"]').content;
Axios.defaults.headers.common["X-CSRF-Token"] = token;

const success = () => {
  if (!document.getElementById("categoriesAlert-s")) return;
  document.getElementById("categoriesAlert-s").style.display = "block";
  setTimeout(
    () =>
      (document.getElementById("categoriesAlert-s").style.display = "none"),
    5000
  );
  document.getElementById('modalClose').click()
};

const error = () => {
  if(!document.getElementById("categoriesAlert-e")) return;
  document.getElementById("categoriesAlert-e").style.display = "block";
  setTimeout(
    () => (document.getElementById("categoriesAlert-e").style.display = "none"),
    5000
  );
};

export const getCategories = (page, pageCount, filterParams) => (dispatch) => {
  dispatch(setCategoriesLoading());
  Axios.get(`/api/v1/repricings/categories?page=${page}&per_page=${pageCount}${filterParams}`)
    .then((res) => {
      dispatch({
        type: TCH_GET_CATEGORIES,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const getCategory = (id) => (dispatch) => {
  dispatch(setCategoryLoading());
  Axios.get(`/api/v1/repricings/categories/${id}`)
    .then((res) => {
      dispatch({
        type: TCH_GET_CATEGORY,
        payload: res,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response,
      });
    });
};

export const updateCategory = (_id, body, indexOfArray) => dispatch => {
  dispatch(setCategoryLoading());
  Axios.post(`/api/v1/repricings/categories/create_priorities`, body)
    .then(res => {
      dispatch(clearErrors());
      dispatch({
        type: TCH_UPDATE_CATEGORY,
        payload: res,
        payload_id: _id
      });
      success("update");
    })
    .catch(err => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response
      });
      error();
    });
};

export const updateMarking = (body, indexOfArray) => dispatch => {
  Axios.patch(`/api/v1/repricings/categories/update_marking`, body)
    .then(res => {
      dispatch(clearErrors());
      dispatch({
        type: TCH_UPDATE_MARKING,
        payload: res.data
      });
      success("update");
    })
    .catch(err => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      });
      error();
    });
};

export const setCategoriesLoading = () => {
  return {
    type: TCH_LOADING_CATEGORIES,
  };
};

export const setCategoryLoading = () => {
  return {
    type: TCH_LOADING_CATEGORY,
  };
};

export const clearErrors = () => {
  return {
    type: CLEAR_ERRORS,
  };
};
